module.exports = __webpack_public_path__ + "img/game07.d9740344.png";